import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RenewalTimelineAdapterService } from '@workspace-app/shared/timeline/services/renewal-timeline-adapter.service';
import { TimelineConfig } from '@workspace-app/shared/timeline/models/timeline-config.model';
import {
  TimelineFilter as SharedTimelineFilter,
  TimelineItem as SharedTimelineItem,
  TimelineItemType as SharedTimelineItemType,
  TimelineUser as SharedTimelineUser,
} from '@workspace-app/shared/timeline/models/timeline-item.model';

// Re-export for backward compatibility
export type TimelineItemType = SharedTimelineItemType;
export type TimelineUser = SharedTimelineUser;
export type TimelineItem = SharedTimelineItem;
export type TimelineFilter = SharedTimelineFilter;

@Injectable({
  providedIn: 'root',
})
export class RenewalTimelineService {
  private adapterService = inject(RenewalTimelineAdapterService);
  constructor() {}

  /**
   * Fetch all timeline items for a License Renewal (notes + events)
   */
  getTimelineItems(reviewId: string): Observable<TimelineItem[]> {
    const config: TimelineConfig = {
      entityType: 'LicenseRenewalWorkflow',
      entityId: reviewId,
      eventEntityTypes: ['LicenseRenewalWorkflow'],
      itemMappers: this.adapterService.getReviewTimelineMappers(),
      sortOrder: 'desc',
      fetchEvents: true,
      fetchNotes: true,
    };

    return this.adapterService.getTimelineItems(config) as Observable<TimelineItem[]>;
  }

  /**
   * Apply filters to timeline items
   */
  filterTimelineItems(items: TimelineItem[], filter: TimelineFilter): TimelineItem[] {
    return this.adapterService.filterTimelineItems(items, filter) as TimelineItem[];
  }
}
